import HolderWrapper from './HolderWrapper';

export default HolderWrapper;
